import { FormState } from "./types";

const initialState = (): FormState => ({
  assignment: {
    selectedStatusFilterIndex: {
      value: 0
    },
    selectedYearFilter: {
      value: new Date().getFullYear().toString()
    }
  },
  authentication: {
    email: {
      error: "",
      value: ""
    },
    tmpPassword: {
      error: "",
      value: ""
    }
  }
});

const formState = initialState();

export { formState };
